<template>
  <div class="wrapper dashboard-wrapper whopperco-wrapper">
    <side-bar>
      <template slot="links">
        <div>
          <sidebar-item class="mb-4" :link="{ name: 'Dashboard',     icon: 'dashbaordicon menu-icons',    path: '/whopperco/dashboard'    }" />
          <sidebar-item class="mb-4" :link="{ name: 'My Courses',    icon: 'menu-icons coursesicon',      path: '/whopperco/courses'      }" />
          <sidebar-item class="mb-4" :link="{ name: 'Certificates',  icon: 'menu-icons certificatesicon', path: '/whopperco/certificates' }" />
          <sidebar-item class="mb-4" :link="{ name: 'Notifications', icon: 'menu-icons notification-ico', path: '/whopperco/notifications'}" />
          <sidebar-item class="mb-4" :link="{ name: 'Documents',     icon: 'menu-icons documents',        path: '/whopperco/documents'    }" />
          <sidebar-item class="mb-4" :link="{ name: 'Onboarding',    icon: 'menu-icons user-icon',        path: '/whopperco/onboarding'   }" />
          <sidebar-item class="mb-4" :link="{ name: 'Tutorial Video',icon: 'menu-icons TutorialVideosicon', path: '/whopperco/tutorial'   }" />
          <sidebar-item class="mb-4 d-md-none" @click.native="signOut" :link="{ name: 'Logout', icon: 'menu-icons logout-icon', path: '/login' }" />
        </div>
      </template>
    </side-bar>

    <div class="main-content px-4">
      <!-- Top navbar (mirrors HOT DashboardNavbar pattern) -->
      <nav class="whopperco-navbar">
        <div class="whopperco-search-wrap" v-click-outside="closeSearch">
          <div class="whopperco-search" :class="{ open: searchOpen && searchResults.length > 0 }">
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
              <path d="M15.0258 13.8475L18.595 17.4159L17.4158 18.595L13.8475 15.0259C12.5198 16.0902 10.8683 16.6691 9.16667 16.6667C5.02667 16.6667 1.66667 13.3067 1.66667 9.16669C1.66667 5.02669 5.02667 1.66669 9.16667 1.66669C13.3067 1.66669 16.6667 5.02669 16.6667 9.16669C16.6691 10.8684 16.0902 12.5198 15.0258 13.8475Z" fill="#9ca3af"/>
            </svg>
            <input type="text" placeholder="Search courses, certificates, documents…"
              v-model="searchQ" @focus="searchOpen = true" @keydown.esc="closeSearch" />
            <button v-if="searchQ" class="whopperco-search-clear" @click="searchQ = ''" aria-label="Clear">×</button>
          </div>

          <div v-if="searchOpen && searchQ" class="whopperco-search-dropdown">
            <div v-if="searchResults.length === 0" class="whopperco-search-empty">
              No matches for <strong>"{{ searchQ }}"</strong>. Try a course name or "certificates".
            </div>
            <div v-else class="whopperco-search-results">
              <div v-for="group in searchGroups" :key="group.label" v-if="group.items.length" class="whopperco-search-group">
                <p class="whopperco-search-group-label">{{ group.label }} <span class="whopperco-search-group-count">{{ group.items.length }}</span></p>
                <a v-for="r in group.items" :key="r.key" href="#"
                  class="whopperco-search-result"
                  @click.prevent="goToSearchResult(r)">
                  <span class="whopperco-search-result-icon" :style="{ background: r.color }">{{ r.icon }}</span>
                  <div class="flex-grow-1">
                    <p class="m-0">{{ r.title }}</p>
                    <p class="text-secondary small m-0">{{ r.subtitle }}</p>
                  </div>
                  <span class="whopperco-search-result-arrow">→</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="whopperco-navbar-right">
          <button class="whopperco-icon-btn" aria-label="Notifications" @click="$router.push('/whopperco/notifications')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#502314" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 17h5l-1.4-1.4A2 2 0 0118 14.2V11a6 6 0 10-12 0v3.2c0 .5-.2 1-.6 1.4L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
            </svg>
            <span class="whopperco-icon-dot"></span>
          </button>
          <div class="whopperco-user">
            <span class="whopperco-user-name">Sabrina Cruz</span>
            <span class="whopperco-user-role">Employee · Store BK-2241</span>
          </div>
          <span class="whopperco-avatar">SC</span>
        </div>
      </nav>

      <div class="content">
        <!-- ===== DASHBOARD (overview) ===== -->
        <template v-if="view === 'dashboard'">
          <div class="dashbaord-row-card">
            <div class="row">
              <div class="col-md-12"></div>
              <div class="col-xl-12">
                <div class="dash-header mb-4">
                  <h2 class="text-default m-0 d-flex">
                    Hi, {{ usrname }} <img src="/signup-img/fire.svg" alt="" />
                  </h2>
                  <p class="text-secondary">{{ dashboardWelcomeTagline }}</p>
                  <router-link to="/whopperco/courses" class="d-none d-sm-block">
                    <button class="btn btn-primary font-weight-normal px-4">My Courses</button>
                  </router-link>
                </div>
              </div>
            </div>

            <!-- Onboarding callout — neutral card with red accent strip, not a colored alert -->
            <div v-if="!onboardingComplete" class="onboarding-callout">
              <div class="onboarding-callout-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/>
                </svg>
              </div>
              <div class="onboarding-callout-body">
                <p class="onboarding-callout-title">Finish your onboarding</p>
                <p class="onboarding-callout-desc">{{ onboardingItemsLeft }} pending steps — banking info, ID upload, and franchise agreement.</p>
              </div>
              <router-link to="/whopperco/onboarding" class="onboarding-callout-cta">Complete onboarding →</router-link>
            </div>

            <!-- Course Overview stat row -->
            <div class="card top-cardheader">
              <div class="card-header border-bottom px-0 px-sm-4 py-3 d-flex justify-content-between align-items-center">
                <h5 class="font-weight-normal text-default m-0">Course Overview</h5>
              </div>
              <div class="row m-0">
                <div class="col-xl-3 col-md-6 p-0">
                  <router-link class="nav-item" to="/whopperco/courses?status=open">
                    <div class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                      <div class="card-value-box">
                        <div class="card-icon-img"><img src="/img/svg-icons/opened_courses.svg" /></div>
                        <div class="card-left flex-grow-1 pl-3">
                          <h5 class="font-weight-normal m-0">Open Courses</h5>
                          <span>{{ openCount }}</span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-xl-3 col-md-6 p-0">
                  <router-link class="nav-item" to="/whopperco/courses?status=passed">
                    <div class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                      <div class="card-value-box">
                        <div class="card-icon-img"><img src="/img/svg-icons/passesd_courses.svg" /></div>
                        <div class="card-left flex-grow-1 pl-3">
                          <h5 class="font-weight-normal m-0">Passed Courses</h5>
                          <span>{{ passedCount }}</span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-xl-3 col-md-6 p-0">
                  <router-link class="nav-item" to="/whopperco/courses?status=failed">
                    <div class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                      <div class="card-value-box">
                        <div class="card-icon-img"><img src="/img/svg-icons/failed_courses.svg" /></div>
                        <div class="card-left flex-grow-1 pl-3">
                          <h5 class="font-weight-normal m-0">Failed Courses</h5>
                          <span>{{ failedCount }}</span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-xl-3 col-md-6 p-0">
                  <router-link class="nav-item" to="/whopperco/courses?status=expired">
                    <div class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                      <div class="card-value-box">
                        <div class="card-icon-img"><img src="/img/svg-icons/expired_courses.svg" /></div>
                        <div class="card-left flex-grow-1 pl-3">
                          <h5 class="font-weight-normal m-0">Overdue Courses</h5>
                          <span>{{ expiredCount }}</span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <!-- Required Courses preview -->
          <div class="data-wrap">
            <div class="card no-border-card courses employee-content-wrap" style="margin-top: 20px">
              <div class="card-header">
                <div class="row" style="padding-bottom: 0px !important">
                  <div class="col-md-6"><h2>Required Courses</h2></div>
                  <div class="col-md-6 text-right">
                    <router-link to="/whopperco/courses" class="text-primary font-weight-bold">View all →</router-link>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="grid-action-boxes">
                  <div class="row">
                    <div class="col-md-4 mb-4" v-for="course in topCourses" :key="course.id">
                      <div class="grid-wrap border rounded p-3">
                        <span class="img-wrap position-relative">
                          <img class="d-block mx-auto w-100 mb-3" :src="course.img || '/placeholder.jpg'" style="height: 200px; object-fit: cover;" />
                          <a class="play-btn" href="#" @click.prevent="takingCourse(course)"><img src="/play_btn.svg" alt="" /></a>
                          <span v-if="course.is_new" class="course-new-badge">NEW</span>
                        </span>
                        <div class="grid-header d-flex justify-content-between"><h5 class="mb-4">{{ course.course_name }}</h5></div>
                        <div class="course-status mb-4">
                          <span class="failed"  v-if="course.course_status === 2">Open</span>
                          <span class="passed"  v-if="course.course_status === 1">Passed</span>
                          <span class="expired" v-if="course.course_status === 0">Failed</span>
                          <span class="expired" v-if="course.course_status === 3">Overdue</span>
                        </div>
                        <div class="progress-area mb-4">
                          <div class="progress-top-row d-flex justify-content-between">
                            <span class="assigned">Due Date : {{ course.due_date }}</span>
                            <span class="time">⏱ {{ course.course_length }} min</span>
                          </div>
                        </div>
                        <div class="action-area d-flex justify-content-between">
                          <button type="button" class="btn btn-primary btn-outline-primary px-3 py-2 w-100" @click="takingCourse(course)">
                            {{ course.course_status === 1 ? 'Review Course' : course.course_status === 0 ? 'Retake Course' : 'Take Course' }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- ===== MY COURSES (full filtered grid) ===== -->
        <template v-else-if="view === 'courses'">
          <div class="dash-header mb-4">
            <h2 class="text-default m-0 d-flex">My Courses <img src="/signup-img/fire.svg" alt="" /></h2>
            <p class="text-secondary">Your full assigned course catalog.</p>
          </div>
          <div class="filter-bar mb-3">
            <button v-for="f in courseFilters" :key="f.key"
              class="btn" :class="activeFilter === f.key ? 'btn-primary' : 'btn-outline-primary'"
              @click="activeFilter = f.key">
              {{ f.label }} ({{ f.count }})
            </button>
          </div>
          <div class="card no-border-card courses employee-content-wrap">
            <div class="card-body">
              <span v-if="visibleCourses.length > 0">
                <div class="grid-action-boxes">
                  <div class="row">
                    <div class="col-md-4 mb-4" v-for="course in visibleCourses" :key="course.id">
                      <div class="grid-wrap border rounded p-3">
                        <span class="img-wrap position-relative">
                          <img class="d-block mx-auto w-100 mb-3" :src="course.img || '/placeholder.jpg'" style="height: 200px; object-fit: cover;" />
                          <a class="play-btn" href="#" @click.prevent="takingCourse(course)"><img src="/play_btn.svg" alt="" /></a>
                          <span v-if="course.is_new" class="course-new-badge">NEW</span>
                        </span>
                        <div class="grid-header d-flex justify-content-between"><h5 class="mb-4">{{ course.course_name }}</h5></div>
                        <div class="course-status mb-4">
                          <span class="failed"  v-if="course.course_status === 2">Open</span>
                          <span class="passed"  v-if="course.course_status === 1">Passed</span>
                          <span class="expired" v-if="course.course_status === 0">Failed</span>
                          <span class="expired" v-if="course.course_status === 3">Overdue</span>
                        </div>
                        <div class="progress-area mb-4">
                          <div class="progress-top-row d-flex justify-content-between">
                            <span class="assigned">Due Date : {{ course.due_date }}</span>
                            <span class="time">⏱ {{ course.course_length }} min</span>
                          </div>
                        </div>
                        <div class="action-area d-flex justify-content-between">
                          <button type="button" class="btn btn-primary btn-outline-primary px-3 py-2 w-100" @click="takingCourse(course)">
                            {{ course.course_status === 1 ? 'Review Course' : course.course_status === 0 ? 'Retake Course' : 'Take Course' }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
              <span v-else>
                <div class="grid-wrap border rounded p-3 text-center">
                  <p class="m-0 text-secondary">No courses match this filter.</p>
                </div>
              </span>
            </div>
          </div>
        </template>

        <!-- ===== CERTIFICATES ===== -->
        <template v-else-if="view === 'certificates'">
          <div class="dash-header mb-4">
            <h2 class="text-default m-0 d-flex">Certificates <img src="/signup-img/fire.svg" alt="" /></h2>
            <p class="text-secondary">Courses you've completed and the certificates you've earned.</p>
          </div>
          <div class="card no-border-card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4 mb-4" v-for="c in completedCourses" :key="c.id">
                  <div class="cert-card border rounded p-4 text-center">
                    <div class="cert-ribbon">🏅</div>
                    <h4 class="mt-3 mb-1">{{ c.course_name }}</h4>
                    <p class="text-secondary small mb-2">Issued {{ c.due_date }} · Valid through {{ certValidThrough(c) }}</p>
                    <button class="btn btn-outline-primary btn-sm">Download PDF</button>
                  </div>
                </div>
                <div class="col-12" v-if="completedCourses.length === 0">
                  <div class="grid-wrap border rounded p-4 text-center">
                    <p class="m-0 text-secondary">No certificates yet. Complete a course to earn your first one.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- ===== NOTIFICATIONS ===== -->
        <template v-else-if="view === 'notifications'">
          <div class="dash-header mb-4">
            <h2 class="text-default m-0 d-flex">Notifications <img src="/signup-img/fire.svg" alt="" /></h2>
            <p class="text-secondary">Updates from your GM, course assignments, and platform announcements.</p>
          </div>
          <div class="card no-border-card">
            <div class="card-body">
              <ul class="notif-list">
                <li v-for="n in notifications" :key="n.id" class="notif-item d-flex" :class="n.unread ? 'unread' : ''">
                  <span class="notif-dot">{{ n.icon }}</span>
                  <div class="flex-grow-1">
                    <p class="mb-1"><strong>{{ n.title }}</strong></p>
                    <p class="mb-0 text-secondary small">{{ n.body }}</p>
                  </div>
                  <span class="text-secondary small">{{ n.when }}</span>
                </li>
              </ul>
            </div>
          </div>
        </template>

        <!-- ===== DOCUMENTS ===== -->
        <template v-else-if="view === 'documents'">
          <div class="dash-header mb-4">
            <h2 class="text-default m-0 d-flex">Documents <img src="/signup-img/fire.svg" alt="" /></h2>
            <p class="text-secondary">Your I-9, W-4, signed franchise agreement, and other employment paperwork.</p>
          </div>
          <div class="onboarding-callout onboarding-callout-compact">
            <div class="onboarding-callout-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/>
              </svg>
            </div>
            <div class="onboarding-callout-body">
              <p class="onboarding-callout-title">Missing a document?</p>
              <p class="onboarding-callout-desc">Upload it from your onboarding flow — takes 2 minutes.</p>
            </div>
            <router-link to="/whopperco/onboarding" class="onboarding-callout-cta">Open onboarding →</router-link>
          </div>
          <div class="card no-border-card">
            <div class="card-body">
              <table class="table">
                <thead>
                  <tr><th>Document</th><th>Status</th><th>Uploaded</th><th></th></tr>
                </thead>
                <tbody>
                  <tr v-for="d in documents" :key="d.id">
                    <td><strong>{{ d.name }}</strong></td>
                    <td><span class="badge" :class="d.uploaded ? 'badge-success' : 'badge-warning'">{{ d.uploaded ? 'On file' : 'Missing' }}</span></td>
                    <td class="text-secondary">{{ d.uploaded || '—' }}</td>
                    <td class="text-right">
                      <button v-if="d.uploaded" class="btn btn-outline-primary btn-sm">View</button>
                      <router-link v-else to="/whopperco/onboarding" class="btn btn-primary btn-sm">Upload</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>

        <!-- ===== TUTORIAL: guided tours (mirrors HOT v-intro pattern) ===== -->
        <template v-else-if="view === 'tutorial'">
          <div class="dash-header mb-4">
            <h2 class="text-default m-0 d-flex">Tutorial &amp; Tours <img src="/signup-img/fire.svg" alt="" /></h2>
            <p class="text-secondary">Step-by-step walkthroughs of the Whopperco platform.</p>
          </div>

          <div class="card no-border-card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
              <div>
                <h5 class="mb-1">Take the guided tour</h5>
                <p class="text-secondary small mb-0">Click below to launch an interactive walkthrough — we'll highlight each feature in order.</p>
              </div>
              <button class="btn btn-primary" @click="startTour">▶ Start tour</button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-lg-4 mb-3" v-for="t in tours" :key="t.id">
              <div class="card no-border-card h-100 tour-card" @click="visitTour(t)">
                <div class="card-body">
                  <span class="tour-icon" :style="{ background: t.color }">{{ t.icon }}</span>
                  <p class="tour-step text-secondary small mb-1">{{ t.duration }}</p>
                  <h4 class="mb-2 tour-title">{{ t.title }}</h4>
                  <p class="text-secondary small mb-3">{{ t.desc }}</p>
                  <a class="font-weight-bold text-primary" href="#" @click.prevent="visitTour(t)">Open page →</a>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- Course-launch modal -->
    <div v-if="openModal" class="whopperco-modal-backdrop" @click.self="openModal = null">
      <div class="whopperco-modal">
        <button class="whopperco-modal-close" @click="openModal = null" aria-label="Close">×</button>
        <p class="whopperco-modal-id">Course #{{ openModal.id }}</p>
        <h2 class="whopperco-modal-title">{{ openModal.course_name }}</h2>
        <p class="whopperco-modal-meta">⏱ {{ openModal.course_length }} minutes · Due {{ openModal.due_date }}</p>
        <div class="whopperco-modal-body">
          <p>Prototype course-launch modal. In production, this opens the SCORM player for <strong>{{ openModal.course_name }}</strong>.</p>
          <p class="whopperco-modal-stub">📺 SCORM player placeholder</p>
        </div>
        <div class="whopperco-modal-actions">
          <button class="whopperco-modal-secondary" @click="openModal = null">Maybe later</button>
          <button class="whopperco-modal-primary" @click="launchCourse">Launch course</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const clickOutside = {
  bind(el, binding) {
    el.__handler = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };
    document.addEventListener('click', el.__handler);
  },
  unbind(el) {
    document.removeEventListener('click', el.__handler);
  },
};

export default {
  name: 'WhopperDashboard',
  directives: { 'click-outside': clickOutside },
  data() {
    return {
      usrname: 'Sabrina',
      dashboardWelcomeTagline: 'Pick up where you left off — your assigned BK courses are below.',
      activeFilter: 'all',
      openModal: null,
      searchQ: '',
      searchOpen: false,
      tableData: [
        { id: 442, course_name: 'Burger King — Active Shooter Training',         course_length: 25, due_date: '05/18/2026', course_status: 1, img: '/signup-img/whopperco/courses/active-shooter.svg',  is_new: false },
        { id: 443, course_name: 'Burger King — Armed Robbery',                   course_length: 22, due_date: '05/18/2026', course_status: 1, img: '/signup-img/whopperco/courses/armed-robbery.svg',   is_new: false },
        { id: 444, course_name: 'Burger King — Conflict Resolution',             course_length: 19, due_date: '06/04/2026', course_status: 2, img: '/signup-img/whopperco/courses/conflict.svg',        is_new: false },
        { id: 449, course_name: 'Burger King — Difficult Customer',              course_length: 18, due_date: '06/04/2026', course_status: 2, img: '/signup-img/whopperco/courses/difficult-customer.svg', is_new: false },
        { id: 446, course_name: 'Burger King — Violence in the Workplace',       course_length: 24, due_date: '05/25/2026', course_status: 2, img: '/signup-img/whopperco/courses/violence.svg',        is_new: false },
        { id: 447, course_name: 'Burger King — Workplace Bullying',              course_length: 20, due_date: '05/25/2026', course_status: 2, img: '/signup-img/whopperco/courses/bullying.svg',        is_new: false },
        { id: 445, course_name: 'Burger King — Workplace Social Media',          course_length: 17, due_date: '06/04/2026', course_status: 2, img: '/signup-img/whopperco/courses/social-media.svg',    is_new: false },
        { id: 450, course_name: 'Burger King Food Handler Cert — Florida',       course_length: 75, due_date: '05/14/2026', course_status: 2, img: '/signup-img/whopperco/courses/food-handler-fl.svg', is_new: false },
        { id: 436, course_name: 'Burger King — Burn Prevention',                 course_length: 16, due_date: '05/09/2026', course_status: 3, img: '/signup-img/whopperco/courses/burn-prevention.svg', is_new: false },
        { id: 437, course_name: 'Burger King — Fryer Safety',                    course_length: 18, due_date: '05/14/2026', course_status: 2, img: '/signup-img/whopperco/courses/fryer-safety.svg',    is_new: false },
        { id: 901, course_name: 'Food Manager Online Exam',                      course_length: 90, due_date: '07/10/2026', course_status: 2, img: '/signup-img/whopperco/courses/food-manager.svg',    is_new: false },
        { id: 902, course_name: 'Form I-9 & E-Verify Training',                  course_length: 30, due_date: '05/14/2026', course_status: 2, img: '/signup-img/whopperco/courses/i9-everify.svg',      is_new: false },
        { id: 1001, course_name: 'Benefits',                                      course_length: 14, due_date: '—',          course_status: 2, img: '/signup-img/whopperco/courses/benefits.svg',         is_new: true  },
      ],
      notifications: [
        { id: 1, icon: '📚', title: 'New course assigned: Benefits',   body: 'Your GM added "Benefits" to your training plan.',         when: '2h ago', unread: true },
        { id: 2, icon: '⏰', title: 'Burn Prevention is overdue',       body: 'This was due 05/09. Please complete it today.',          when: '1d ago', unread: true },
        { id: 3, icon: '✅', title: 'You passed Armed Robbery',         body: 'Great work. Certificate added to your file.',            when: '3d ago', unread: false },
        { id: 4, icon: '📅', title: 'Food Handler Cert due in 3 days', body: 'Renewal required by 05/14.',                             when: '4d ago', unread: false },
        { id: 5, icon: '👋', title: 'Welcome to Whopperco',            body: 'Your account is active. Complete onboarding to begin.', when: '7d ago', unread: false },
      ],
      documents: [
        { id: 1, name: 'I-9 Employment Verification',        uploaded: '05/08/2026' },
        { id: 2, name: 'W-4 Tax Withholding',                uploaded: '05/08/2026' },
        { id: 3, name: 'Direct Deposit Form',                uploaded: null },
        { id: 4, name: 'Government-Issued ID (front)',       uploaded: null },
        { id: 5, name: 'Franchise Agreement (countersigned)', uploaded: null },
        { id: 6, name: 'Food Handler Card — Florida',        uploaded: '05/10/2026' },
      ],
      tours: [
        { id: 'login',     icon: '🔑', color: 'linear-gradient(135deg, #e48e39 0%, #ea2628 100%)', duration: '0:30',  title: 'Logging in with your employee ID',     desc: 'Your employee ID + DOB on first sign-in. Or use Docebo SSO.',         path: '/login' },
        { id: 'dashboard', icon: '🏠', color: 'linear-gradient(135deg, #0c4a6e 0%, #0284c7 100%)', duration: '1:00',  title: 'Reading your dashboard',                desc: 'Open / Passed / Failed / Overdue at a glance.',                       path: '/whopperco/dashboard' },
        { id: 'courses',   icon: '📚', color: 'linear-gradient(135deg, #ea2628 0%, #c01618 100%)', duration: '1:30',  title: 'Finding and taking a course',           desc: 'Filter by status, launch SCORM, track progress.',                     path: '/whopperco/courses' },
        { id: 'certs',     icon: '🏅', color: 'linear-gradient(135deg, #166534 0%, #22c55e 100%)', duration: '0:45',  title: 'Downloading your certificates',         desc: 'Earned certs land here automatically — PDF export ready.',            path: '/whopperco/certificates' },
        { id: 'onboard',   icon: '🪪', color: 'linear-gradient(135deg, #e48e39 0%, #ea2628 100%)', duration: '2:00',  title: 'Completing onboarding',                 desc: 'Upload bank info, ID, sign your franchise agreement.',                path: '/whopperco/onboarding' },
        { id: 'help',      icon: '❓', color: 'linear-gradient(135deg, #4b5563 0%, #6b7280 100%)', duration: '0:30',  title: 'Where to get help',                     desc: 'Ask your GM, email support@whopperco.com, or live chat.',             path: '/whopperco/notifications' },
      ],
    };
  },
  computed: {
    view() {
      const map = {
        WhopperDashboard: 'dashboard',
        WhopperCourses: 'courses',
        WhopperCertificates: 'certificates',
        WhopperNotifications: 'notifications',
        WhopperDocuments: 'documents',
        WhopperTutorial: 'tutorial',
      };
      return map[this.$route.name] || 'dashboard';
    },
    openCount()    { return this.tableData.filter(c => c.course_status === 2).length; },
    passedCount()  { return this.tableData.filter(c => c.course_status === 1).length; },
    failedCount()  { return this.tableData.filter(c => c.course_status === 0).length; },
    expiredCount() { return this.tableData.filter(c => c.course_status === 3).length; },
    completedCourses() { return this.tableData.filter(c => c.course_status === 1); },
    topCourses()       { return this.tableData.slice(0, 3); },
    courseFilters() {
      return [
        { key: 'all',     label: 'All',         count: this.tableData.length },
        { key: 'open',    label: 'Open',        count: this.openCount },
        { key: 'passed',  label: 'Passed',      count: this.passedCount },
        { key: 'failed',  label: 'Failed',      count: this.failedCount },
        { key: 'expired', label: 'Overdue',     count: this.expiredCount },
      ];
    },
    visibleCourses() {
      if (this.activeFilter === 'all') return this.tableData;
      const map = { open: 2, passed: 1, failed: 0, expired: 3 };
      return this.tableData.filter(c => c.course_status === map[this.activeFilter]);
    },
    onboardingComplete() {
      return this.documents.filter(d => !d.uploaded).length === 0;
    },
    onboardingItemsLeft() {
      return this.documents.filter(d => !d.uploaded).length;
    },
    searchResults() {
      const q = (this.searchQ || '').trim().toLowerCase();
      if (!q) return [];
      // Semantic-ish: split query, score by hit count across tokens
      const tokens = q.split(/\s+/).filter(Boolean);
      const score = (text) => {
        const t = (text || '').toLowerCase();
        return tokens.reduce((acc, tok) => acc + (t.includes(tok) ? 1 : 0), 0);
      };
      const results = [];

      // Courses
      for (const c of this.tableData) {
        const s = score(c.course_name + ' ' + this.statusWord(c.course_status));
        if (s > 0) results.push({ kind: 'course', key: 'c-' + c.id, title: c.course_name, subtitle: 'Course · ' + this.statusWord(c.course_status) + ' · ' + c.course_length + ' min', icon: '📚', color: 'linear-gradient(135deg, #e48e39 0%, #ea2628 100%)', score: s, path: '/whopperco/courses?status=' + this.statusFilterForCourse(c) });
      }
      // Certificates (only passed courses)
      for (const c of this.completedCourses) {
        const s = score(c.course_name + ' certificate');
        if (s > 0) results.push({ kind: 'certificate', key: 'cert-' + c.id, title: c.course_name + ' — Certificate', subtitle: 'Certificate · Issued ' + c.due_date, icon: '🏅', color: 'linear-gradient(135deg, #166534 0%, #22c55e 100%)', score: s, path: '/whopperco/certificates' });
      }
      // Documents
      for (const d of this.documents) {
        const s = score(d.name + ' document');
        if (s > 0) results.push({ kind: 'document', key: 'doc-' + d.id, title: d.name, subtitle: d.uploaded ? 'Document · On file ' + d.uploaded : 'Document · Missing', icon: '📄', color: 'linear-gradient(135deg, #0c4a6e 0%, #0284c7 100%)', score: s, path: '/whopperco/documents' });
      }
      // Sidebar / pages
      const pages = [
        { title: 'Dashboard',     subtitle: 'Page · Overview',         path: '/whopperco/dashboard' },
        { title: 'My Courses',    subtitle: 'Page · Training catalog', path: '/whopperco/courses' },
        { title: 'Certificates',  subtitle: 'Page · Earned awards',    path: '/whopperco/certificates' },
        { title: 'Notifications', subtitle: 'Page · Activity feed',    path: '/whopperco/notifications' },
        { title: 'Documents',     subtitle: 'Page · Employment docs',  path: '/whopperco/documents' },
        { title: 'Onboarding',    subtitle: 'Page · Setup wizard',     path: '/whopperco/onboarding' },
        { title: 'Tutorial',      subtitle: 'Page · Guided tours',     path: '/whopperco/tutorial' },
      ];
      for (const p of pages) {
        const s = score(p.title + ' ' + p.subtitle);
        if (s > 0) results.push({ kind: 'page', key: 'page-' + p.path, title: p.title, subtitle: p.subtitle, icon: '🧭', color: 'linear-gradient(135deg, #502314 0%, #6b7280 100%)', score: s, path: p.path });
      }
      return results.sort((a, b) => b.score - a.score).slice(0, 12);
    },
    searchGroups() {
      const groups = {
        Courses:       { label: 'Courses',       items: [] },
        Certificates:  { label: 'Certificates',  items: [] },
        Documents:     { label: 'Documents',     items: [] },
        Pages:         { label: 'Pages',         items: [] },
      };
      for (const r of this.searchResults) {
        if (r.kind === 'course')      groups.Courses.items.push(r);
        if (r.kind === 'certificate') groups.Certificates.items.push(r);
        if (r.kind === 'document')    groups.Documents.items.push(r);
        if (r.kind === 'page')        groups.Pages.items.push(r);
      }
      return Object.values(groups);
    },
  },
  watch: {
    '$route.query.status': {
      immediate: true,
      handler(status) {
        if (status && this.view === 'courses') {
          this.activeFilter = status;
        }
      },
    },
  },
  methods: {
    takingCourse(course) { this.openModal = course; },
    launchCourse() { this.openModal = null; },
    signOut() {
      try { localStorage.removeItem('whopperco.docebo.session'); } catch (e) {}
      this.$router.push('/login');
    },
    closeSearch() { this.searchOpen = false; },
    goToSearchResult(r) {
      this.searchOpen = false;
      this.searchQ = '';
      this.$router.push(r.path);
    },
    statusWord(s) { return s === 1 ? 'Passed' : s === 0 ? 'Failed' : s === 3 ? 'Overdue' : 'Open'; },
    statusFilterForCourse(c) { return c.course_status === 1 ? 'passed' : c.course_status === 0 ? 'failed' : c.course_status === 3 ? 'expired' : 'open'; },
    visitTour(t) { this.$router.push(t.path); },
    startTour() {
      try {
        const introJs = require('intro.js').default || require('intro.js');
        const intro = introJs();
        intro.setOptions({ showProgress: true, exitOnOverlayClick: true, nextLabel: 'Next →', prevLabel: '← Back', doneLabel: 'Got it!' });
        intro.start();
      } catch (e) {
        // intro.js not available — fall back to walking through tour pages
        this.$router.push('/whopperco/dashboard');
      }
    },
    certValidThrough(c) {
      const [m, d, y] = c.due_date.split('/');
      return `${m}/${d}/${Number(y) + 1}`;
    },
  },
};
</script>

<style scoped>
.whopperco-wrapper { font-family: "Inter", "Nunito", sans-serif; }

/* ===== Top navbar (HOT-style) ===== */
.whopperco-navbar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 0 22px;
  margin-bottom: 8px;
}

.whopperco-search-wrap { flex: 1; max-width: 540px; position: relative; }
.whopperco-search {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 8px 18px;
  transition: border-color 0.2s, box-shadow 0.2s, border-radius 0.15s;
}
.whopperco-search.open { border-radius: 22px 22px 0 0; border-bottom-color: transparent; }
.whopperco-search:focus-within {
  border-color: #ea2628;
  box-shadow: 0 0 0 4px rgba(234, 38, 40, 0.08);
}
.whopperco-search.open:focus-within { box-shadow: none; }
.whopperco-search input {
  border: 0;
  background: transparent;
  outline: 0;
  flex: 1;
  font-size: 14px;
  color: #1e1e1e;
  padding: 4px 0;
  min-width: 0;
}
.whopperco-search input::placeholder { color: #9ca3af; }

.whopperco-search-clear {
  background: none; border: 0; cursor: pointer;
  color: #9ca3af; font-size: 20px; line-height: 1;
  width: 22px; height: 22px;
}

.whopperco-search-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ea2628;
  border-top: 0;
  border-radius: 0 0 14px 14px;
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.12);
  z-index: 20;
  max-height: 420px;
  overflow-y: auto;
}
.whopperco-search-empty {
  padding: 20px; font-size: 13px; color: #6b7280; text-align: center;
}
.whopperco-search-group { padding: 8px 6px; border-bottom: 1px solid #f3f4f6; }
.whopperco-search-group:last-child { border-bottom: 0; }
.whopperco-search-group-label {
  font-size: 10px; font-weight: 800; letter-spacing: 1px;
  text-transform: uppercase; color: #9ca3af;
  margin: 4px 14px;
  display: flex; align-items: center; gap: 6px;
}
.whopperco-search-group-count {
  background: #f3f4f6; color: #6b7280;
  font-size: 10px; font-weight: 700;
  padding: 1px 6px; border-radius: 999px;
}
.whopperco-search-result {
  display: flex !important;
  align-items: center;
  gap: 12px;
  padding: 8px 14px;
  text-decoration: none !important;
  color: #1e1e1e !important;
  transition: background 0.1s;
}
.whopperco-search-result:hover { background: #fff7ed; }
.whopperco-search-result-icon {
  width: 32px; height: 32px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; flex-shrink: 0;
}
.whopperco-search-result p { line-height: 1.25; }
.whopperco-search-result-arrow {
  color: #9ca3af; opacity: 0; transition: opacity 0.15s, transform 0.15s;
}
.whopperco-search-result:hover .whopperco-search-result-arrow { opacity: 1; transform: translateX(4px); }

/* ===== Tour cards ===== */
.tour-card { cursor: pointer; transition: transform 0.15s, box-shadow 0.2s; }
.tour-card:hover { transform: translateY(-3px); box-shadow: 0 12px 28px rgba(80, 35, 20, 0.12); }
.tour-icon {
  display: inline-flex; align-items: center; justify-content: center;
  width: 48px; height: 48px; border-radius: 12px;
  color: #fff; font-size: 24px; margin-bottom: 14px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}
.tour-step { font-size: 11px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; }
.tour-title { font-size: 15px; font-weight: 700; }

.whopperco-navbar-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 14px;
}

.whopperco-icon-btn {
  background: #fff;
  border: 1px solid #e5e7eb;
  width: 38px;
  height: 38px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: border-color 0.15s;
}
.whopperco-icon-btn:hover { border-color: #ea2628; }
.whopperco-icon-dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #ea2628;
  border: 2px solid #fff;
}

.whopperco-user {
  display: flex;
  flex-direction: column;
  text-align: right;
  line-height: 1.15;
}
.whopperco-user-name { font-size: 14px; font-weight: 700; color: #1e1e1e; }
.whopperco-user-role { font-size: 11px; color: #6b7280; }

.whopperco-avatar {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  background: linear-gradient(135deg, #ea2628 0%, #e48e39 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.5px;
}

@media (max-width: 768px) {
  .whopperco-navbar { flex-wrap: wrap; padding: 12px 0 16px; }
  .whopperco-user { display: none; }
  .whopperco-search { max-width: 100%; width: 100%; }
}

/* Neutral callout — no alert-warning orange, no alert-info blue.
   Pattern: white card + thin red accent strip on the left, dark title, gray desc, outlined CTA. */
.onboarding-callout {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-left: 4px solid #ea2628;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.onboarding-callout-compact {
  margin-bottom: 16px;
  padding: 12px 16px;
}
.onboarding-callout-icon {
  flex-shrink: 0;
  width: 38px; height: 38px;
  border-radius: 999px;
  background: #fff1f0;
  color: #ea2628;
  display: flex; align-items: center; justify-content: center;
}
.onboarding-callout-body { flex: 1; min-width: 0; }
.onboarding-callout-title {
  margin: 0; font-size: 14px; font-weight: 700; color: #1e1e1e;
}
.onboarding-callout-desc {
  margin: 2px 0 0; font-size: 12px; color: #6b7280;
}
.onboarding-callout-cta {
  flex-shrink: 0;
  background: #ea2628;
  color: #fff !important;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  transition: background 0.15s;
}
.onboarding-callout-cta:hover { background: #c01618; color: #fff; text-decoration: none; }

@media (max-width: 640px) {
  .onboarding-callout { flex-wrap: wrap; }
  .onboarding-callout-cta { width: 100%; text-align: center; }
}

.course-new-badge {
  position: absolute; top: 8px; left: 8px;
  background: #ea2628; color: #fff;
  font-size: 10px; font-weight: 800; letter-spacing: 0.5px;
  padding: 4px 8px; border-radius: 4px;
  box-shadow: 0 4px 12px rgba(234, 38, 40, 0.4); z-index: 2;
}

.filter-bar { display: flex; gap: 8px; flex-wrap: wrap; }
.filter-bar .btn { font-size: 13px; padding: 6px 14px; border-radius: 999px; font-weight: 600; }

/* Certificates */
.cert-card { background: linear-gradient(180deg, #fffbeb 0%, #fff 50%); }
.cert-ribbon { font-size: 48px; line-height: 1; }
.cert-card h4 { font-size: 15px; font-weight: 700; min-height: 40px; }

/* Notifications */
.notif-list { list-style: none; padding: 0; margin: 0; }
.notif-item { padding: 14px 0; border-bottom: 1px solid #f3f4f6; gap: 14px; }
.notif-item:last-child { border-bottom: 0; }
.notif-item.unread { background: rgba(234, 38, 40, 0.04); margin: 0 -14px; padding-left: 14px; padding-right: 14px; border-radius: 8px; }
.notif-dot { width: 40px; height: 40px; border-radius: 999px; background: #f5ebdc; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }

/* Tutorial video placeholder */
.tutorial-video-wrap { background: #000; border-radius: 10px; aspect-ratio: 16/9; display: flex; align-items: center; justify-content: center; }
.tutorial-placeholder { color: rgba(255, 255, 255, 0.8); text-align: center; }
.tutorial-play { display: block; font-size: 64px; color: #ea2628; }
.tutorial-chapters { list-style: none; padding: 0; }
.tutorial-chapters li { padding: 10px 14px; border-bottom: 1px solid #f3f4f6; font-size: 14px; cursor: pointer; transition: background 0.15s; }
.tutorial-chapters li:hover { background: #fff7ed; }

/* Modal */
.whopperco-modal-backdrop { position: fixed; inset: 0; background: rgba(30, 14, 5, 0.55); display: flex; align-items: center; justify-content: center; z-index: 100; padding: 16px; }
.whopperco-modal { background: #fff; border-radius: 16px; max-width: 520px; width: 100%; padding: 32px; position: relative; box-shadow: 0 24px 60px rgba(0, 0, 0, 0.4); }
.whopperco-modal-close { position: absolute; top: 14px; right: 14px; background: none; border: 0; font-size: 28px; color: #9ca3af; cursor: pointer; line-height: 1; width: 32px; height: 32px; border-radius: 999px; }
.whopperco-modal-id { font-size: 11px; font-weight: 800; letter-spacing: 1px; color: #9ca3af; margin: 0; }
.whopperco-modal-title { font-size: 22px; font-weight: 800; margin: 6px 0 4px; color: #1e1e1e; }
.whopperco-modal-meta { font-size: 13px; color: #6b7280; margin: 0 0 18px; }
.whopperco-modal-body p { margin: 0 0 12px; color: #4b5563; font-size: 14px; line-height: 1.5; }
.whopperco-modal-stub { background: #f5ebdc; border: 1.5px dashed #d6c2a4; padding: 28px 16px; text-align: center; border-radius: 10px; font-size: 14px; color: #502314 !important; }
.whopperco-modal-actions { display: flex; gap: 10px; justify-content: flex-end; margin-top: 22px; }
.whopperco-modal-secondary, .whopperco-modal-primary { border: 0; padding: 11px 18px; border-radius: 10px; font-size: 13px; font-weight: 700; cursor: pointer; }
.whopperco-modal-secondary { background: #f3f4f6; color: #6b7280; }
.whopperco-modal-primary { background: linear-gradient(to bottom, #e48e39 0%, #ea2628 100%); color: #fff; }
</style>
